/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import split_bundleImg from 'assets/images/split-bundle.png'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Code splitting</h2>
    <p className={styles.description}>
      Когда приложение становится достаточно большим, монолитный бандл со всем исходным кодом загружается, парсится и
      исполняется, долго (секунды, особенно на мобильных). Но если пользователь заходит на страницу логина, не имеет
      смысла загружать остальную часть приложения.{' '}
    </p>
    <p className={styles.description}>
      Секция приложения может импортировать большое количество компонентов, которые не нужны при первой загрузке.
      Необходимо разбивать бандл на отдельные файлы (chunks, чанки) и загружать их динамически, только когда это
      необходимо.{' '}
    </p>
    <img className={styles.img} src={split_bundleImg} alt="split-bundle" />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Динамический импорт в ESM</h3>
      <CopyBlock
        text={`// Статический импорт, всегда в начале файла
import moduleA from './path/to/module-a';

/*
 *  Динамический импорт, где угодно
 * Путь к модулю должен быть полный, без выражений
 */
const loadModuleB = () => import('./path/to/module-b');

/*
 * Можно использовать в любом месте, к примеру при событии
 * import() возвращает обещание
 */
loadModuleB().then(module => {
  // Объект модуля с полем default - дефолтный экспорт
  console.log(module);
});`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        Create React App поддерживает разделение кода и позволяет динамически импортировать части приложения используя{' '}
        <code className={styles.code}>import()</code>.{' '}
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://developers.google.com/web/updates/2017/11/dynamic-import"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dynamic import()
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://github.com/tc39/proposal-dynamic-import#import"
            target="_blank"
            rel="noopener noreferrer"
          >
            proposal-dynamic-import
          </a>
        </li>
      </ul>
    </section>
  </section>
))
